import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Observable, of } from 'rxjs';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { PagesService } from 'src/app/pages/services/pages.service';
import { jobFairFormField } from '../../jobfair/forms/create-jobfair';
import { communityFormFeild } from '../forms/create-community';
import { HubbleService } from '../service/hubble.service';

@Component({
	selector: 'app-community',
	templateUrl: './community.page.html',
	styleUrls: ['./community.page.scss'],
})
export class CommunityPage implements OnInit {
	currentPagePermission = 'hubble_community';

	allCommunities$: Observable<any> = this.hubbleService.fetchAllCommunity();

	communityType = [
		{ id: 1, name: 'normal' },
		{ id: 2, name: 'company' },
		{ id: 3, name: 'others' },
	];

	isCanOpenBox = true;
	constructor(
		private pagesService: PagesService,
		private hubbleService: HubbleService,
		private popoverController: PopoverController,
	) {
		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app',
		);
	}

	ngOnInit() {
		this.hubbleService.initAllCommunity();
		this.hubbleService.loadAllCommunity().subscribe();
	}

	async addCommunity() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Create Community',
					form: communityFormFeild,
					selectOptions: {
						communityType: this.communityType,
					},
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	async updateCommunity(community: any) {
		const communityInfo = {
			email: community.email,
			name: community.name,
			communityType: 1,
			about: community.about_community,
			tagline: community.tagline,
			communityNorms: community.community_norms,
			imgUpload: community.photo,
		};

		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Update Community',
					form: communityFormFeild,
					onSubmitForm: this.onCreate,
					values: { ...communityInfo },
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	onCreate(ref: any, editForm: any) {
		const communityInfo = {
			user_id: '',
			name: editForm.name,
			community_type: editForm.communityType,
			about_community: editForm.about,
			tagline: editForm.tagline,
			community_norms: editForm.communityNorms,
			photo: editForm.imgUpload,
		};

		return ref.hubbleService.addCommunity(communityInfo, editForm.email);
	}

	getEmailAndUpdate(community: any) {
		this.hubbleService
			.getEmailById(community.id)
			.subscribe(({ email }: any) => {
				const communityInfo = {
					email: email,
					name: community.name,
					community_type: community.communityType,
					about_community: community.about,
					tagline: community.tagline,
					community_norms: community.communityNorms,
					photo: community.imgUpload,
				};
				this.updateCommunity(communityInfo);
			});
	}
}
